import React from 'react';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { newViewerIntroRequestMessageUrl } from 'buyside/util/urlHelper';

const ViewerIntroRequestActionsAccepted: React.FC<{
  authorDisplayName: string;
  authorId: string;
  id: string;
}> = ({ id, authorDisplayName, authorId }) => {
  return (
    <>
      <Button
        size={BUTTON_SIZES.TINY}
        text={`Message ${authorDisplayName}`}
        type={BUTTON_TYPES.PRIMARY}
        url={newViewerIntroRequestMessageUrl(id, authorId)}
      />
    </>
  );
};

export default ViewerIntroRequestActionsAccepted;
